/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';

// These will get fingerprinted
const IMAGE_URLS: Record<string, string> = {
  segment: new URL('cio/assets/images/integrations/segment.svg', import.meta.url).toString(),
  customerio: new URL('cio/assets/images/integrations/customerio.svg', import.meta.url).toString(),
  redshift: new URL('cio/assets/images/integrations/redshift.svg', import.meta.url).toString(),
  s3: new URL('cio/assets/images/integrations/s3.svg', import.meta.url).toString(),
  hull: new URL('cio/assets/images/integrations/hull.svg', import.meta.url).toString(),
  census: new URL('cio/assets/images/integrations/census.svg', import.meta.url).toString(),
  stitch: new URL('cio/assets/images/integrations/stitch.svg', import.meta.url).toString(),
  clearbit: new URL('cio/assets/images/integrations/clearbit.svg', import.meta.url).toString(),
  slack: new URL('cio/assets/images/actions/slack.svg', import.meta.url).toString(),
  twilio: new URL('cio/assets/images/actions/twilio.svg', import.meta.url).toString(),
  urban_airship: new URL('cio/assets/images/actions/urban-airship.svg', import.meta.url).toString(),
};

export interface WorkspaceIntegrationCardArgs {
  cardType: 'options' | 'message';
  icon?: string;
  imageKey?: string;
  title: string;
  enabled: boolean;
  isLoading?: boolean;
  beta?: boolean;
  description: string;
  routeName: string;
  routeQuery?: Record<string, string>;
  hideEnabledLabel?: boolean;
  showCustomLabel?: boolean;
  customLabel?: string;
  customLabelClass?: string;
  isAccessible?: boolean;
}

export default class WorkspaceIntegrationCard extends Component<WorkspaceIntegrationCardArgs> {
  get showEnabledLabel() {
    return !this.args.hideEnabledLabel ?? true;
  }

  get imageURL(): string | undefined {
    return this.args.imageKey ? IMAGE_URLS[this.args.imageKey] : undefined;
  }

  get isAccessible(): boolean {
    return this.args.isAccessible ?? true;
  }
}
